<script setup>
defineProps({
    as: String,
    left: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
});
</script>

<template>
    <span
        :class="[`icon-${as}`, 'icon', { 'mr-1': left, 'ml-1': right }]"
        role="presentation"
    />
</template>
